<template>
<div class="after-sale-list list-common">
  <!-- 筛选条件 -->
  <div class="query-div">
    <!-- 已选条件 -->
    <div class="selected-div flex-between">
      <div class="title text-red">售后详情</div>
      <div class="flex">
        <div class="order-btn" @click="handleDetail">订单详情</div>
        <div class="order-btn" @click="handleStep(afterSaleInfo)">查看售后进度</div>
        <div v-if="afterSaleInfo.status === 1 && !afterSaleInfo.isSendBack && (afterSaleInfo.type === 1 || afterSaleInfo.type === 2)" class="order-btn" @click="handleExpress(aftersalesId)">填写快递单号</div>
        <div v-if="afterSaleInfo.status === 0" class="order-btn block" @click="handleUndo(aftersalesId, afterSaleInfo.typeName)">撤销申请</div>
      </div>
    </div>
    <div class="mt10 order-info">
        <div>
            <span class="lable">订单编号</span>
            <span class="value">{{ afterSaleInfo.uniteOrderNo }}</span>
        </div>
        <div>
            <span class="lable">退货时间</span>
            <span class="value">{{ item.sendBackTime }}</span>
        </div>
        <div>
            <span class="lable">订单状态</span>
            <span class="value text-blue">{{ afterSaleInfo.statusName }}</span>
        </div>
        <div>
            <span class="lable">售后类型</span>
            <span class="value">{{ afterSaleInfo.typeName }}</span>
        </div>
        <div>
            <span class="lable">申请原因</span>
            <span class="value">{{afterSaleInfo.reason || '暂无'}}</span>
        </div>
        <div>
            <span class="lable">售后合计</span>
            <span class="value text-org">¥{{afterSaleInfo.totalAmount || 0}}</span>
        </div>
        <div>
            <span class="lable">退货地址</span>
            <span class="value">{{afterSaleInfo.area}}{{afterSaleInfo.address}}</span>
        </div>
        <div>
            <span class="lable">联系人</span>
            <span class="value">{{afterSaleInfo.consignee || '暂无'}}</span>
        </div>
        <div>
            <span class="lable">联系电话</span>
            <span class="value">{{afterSaleInfo.phone || '暂无'}}</span>
        </div>
    </div>
    <div class="mt20">
      <el-table
        :data="afterSaleInfo.aftersalesItems"
        style="border-radius:5px; width: 100%; border: 1px solid rgba(143, 168, 188, 0.5)" :header-cell-style="{background:'#9B232A',color:'#fff', fontSize: '16px'}">
        <el-table-column prop="merchIndustryName" label="店铺名称" align="center" />
        <el-table-column prop="goodsName" label="产品名称" align="center" />
        <el-table-column prop="unitPrice" label="产品单价" align="center" />
        <el-table-column prop="quantity" label="数量" align="center" />
        <el-table-column prop="paymentTotal" label="金额" align="center" />
      </el-table>
    </div>
  </div>
  <!-- 撤销申请 -->
  <UndoDialog :visible="undoDialogVisible" @handleCloseDialog="handleCloseDialog" @handleCancerAftersales="handleCancerAftersales" />
  <!-- 填写快递单号 -->
  <ExpressDialog :visible="expressDialogVisible" :shipCorps="shipCorps" @handleCloseDialog="handleCloseDialog" @handleTransitTabs="handleTransitTabs" />
</div>
</template>

<script>
import UndoDialog from '@/components/UndoDialog'
import ExpressDialog from '@/components/ExpressDialog'
import { loadAftersalesInfo } from '@/api/afterSales'
import { afterSalesMixin } from '@/mixins/afterSalesMixin'
export default {
  name: 'afterSalesDetail',
  mixins: [afterSalesMixin],
  components: {
    UndoDialog,
    ExpressDialog
  },
  data () {
    return {
      aftersalesId: null,
      afterSaleInfo: {},
      tableData: []
    }
  },
  created () {
    this.aftersalesId = this.$route.query.aftersalesId
    this.$nextTick(() => {
      if (this.aftersalesId) {
        this.loadAftersalesInfo()
      }
    })
  },
  methods: {
    // 加载详情
    loadAftersalesInfo () {
      loadAftersalesInfo(this.aftersalesId).then(res => {
        if (res.code === 0) {
          this.afterSaleInfo = res.data
        }
      })
    },
    // 查看详情
    handleDetail () {
      this.$router.push({
        path: 'afterSalesApply',
        query: {}
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/common/css/afterSales.scss';
</style>
